'use strict';

document.addEventListener('DOMContentLoaded', () => {
	let languages = document.querySelectorAll('.js-lang-toggle');

	if(languages) {
		[...languages].forEach((lang) => {
			lang.addEventListener('click', (e) => {
				e.target.classList.toggle('open');
				if (e.target.nextElementSibling) {
					e.target.nextElementSibling.classList.toggle('open');
				}
			});
		});
	}

	document.body.addEventListener('click', (e) => {
		let languagesContainer = e.target.closest('.languages');

		if(!languagesContainer) {
			[...document.querySelectorAll('.languages__dropdown')].forEach((list) => {
				list.classList.remove('open');
			});
			[...languages].forEach((lang) => {
				lang.classList.remove('open');
			});
		}
	});
})
